import { useQuery } from '@tanstack/react-query';

import { ListVoucherUsersQuery, listVoucherUsers } from '~/services/PromoService';

type Params = {
  voucherId?: string;
  query?: ListVoucherUsersQuery;
};

export function useListVoucherUsers({ voucherId, query }: Params) {
  return useQuery({
    queryKey: ['voucher-users', voucherId, query],
    queryFn: async () => {
      if (!voucherId) {
        return null;
      }
      return await listVoucherUsers(voucherId, query || {});
    },
    enabled: Boolean(voucherId),
  });
}
